import { makeAutoObservable } from "mobx"
import PermissionsHelper from '../utilities/PermissionsHelper'
import UserHelper from '../utilities/UserHelper'
import _ from 'lodash'

export default class Permissions {
  
  title = 'Permissions'
  includesPermissions = []
  excludesPermissions = []
  rolePermissions = []
  userPermissions = []
  userRoles = []
  systemPermissions = []
  loggedInUserPermissions = []
  loggedInUserFetched = false
  user = {}

  constructor(){
    makeAutoObservable(this)
  }  

  setIncludes = permissions => {
    this.includesPermissions = permissions
  }

  setExcludes = permissions => {
    this.excludesPermissions = permissions
  }

  getOrgPermissions = async (org) => {
    const fetchedOrgPermissions = await PermissionsHelper.getOrgPermissions(org)
    if (!fetchedOrgPermissions){
      console.error('Issue fetching org permissions')
      return
    }
    this.setIncludes(fetchedOrgPermissions.includePerms || [])
    this.setExcludes(fetchedOrgPermissions.excludePerms || [])
  }

  updateOrgPermissions = async (org, changes, orgId) => {
    // Add changes will be added to includes and remove from exludes
    const newIncludes = _.difference(_.union(this.includesPermissions || [], changes.addChanges), changes.removeChanges)
    // Remove changes will only remove from includes. This prevents the case were we may enable USER_MANAGEMENT_TAB, then remove it
    // at the org level. If we want to then enable it for ADMINs only, this org level excludes would prevent that functionality
    const newExcludes = _.difference(this.excludesPermissions || [], changes.addChanges)
    console.log("New Includes")
    console.log(newIncludes)
    console.log("New Excludes")
    console.log(newExcludes)
    const changedPermissions = [];
    for (const perm of changes?.addChanges) {
      changedPermissions.push({ name: perm, value: 'Added' })
    }
    for (const perm of changes?.removeChanges) {
      changedPermissions.push({ name: perm, value: 'Removed' })
    }
    try {
      await PermissionsHelper.updateOrgPermissions(org, { includes: newIncludes, excludes: newExcludes }, changedPermissions)
    } catch (error) {
      console.error('Error updating org permissions', error)
      throw error
    }
  }

  setRolePermissions = permissions => {
    this.rolePermissions = permissions
  }

  getRolePermissions = async organization => {
    const orgAndRolepermissions = await PermissionsHelper.getRolePermissions(organization)
    this.setRolePermissions(orgAndRolepermissions.rolePermissions)
  }

  updateRolePermissions = async (org, role, permissions, orgId, userId) => {
    console.log('updating role permissions', permissions)
    try {
      await PermissionsHelper.updateRolePermissions(org, role, permissions)
    } catch (error) {
      console.error('Error updating role permissions', error)
      throw error
    }
  }

  setUserPermissions = permissions => {
    this.userPermissions = permissions
  }

  setUserRoles = roles => {
    this.userRoles = roles
  }

  getUserInfo = async email => {
    const user = await UserHelper.getByEmail(email)
    if (!user) return
    console.log(user)

    // Note: We are switching to ownerOrganization instead of organization field. That said we will keep it as a fallback in case we need to revert to the old behavior.
    const org = user.ownerOrganization?.name || user.organization?.name
    const userId = user._id
    const fetchedUserPermissions = await PermissionsHelper.getUserPermissions(org, userId)
    this.setUserPermissions(fetchedUserPermissions)
    this.setUserRoles(user.roles)
  }

  getLoggedInUsersPermissions = async email => {
    const user = await UserHelper.getByEmail(email)
    if (!user) return

    // Note: We are switching to ownerOrganization instead of organization field. That said we will keep it as a fallback in case we need to revert to the old behavior.
    const org = user.ownerOrganization?.name || user.organization?.name
    const userId = user._id
    const fetchedUserPermissions = await PermissionsHelper.getUserPermissions(org, userId)
    this.loggedInUserPermissions = fetchedUserPermissions
    this.loggedInUserFetched = true
    this.user = user
  }

  getSystemPermissions = async () => {
    const fetchedSystemPermissions = await PermissionsHelper.getSystemPermissions()
    this.setSystemPermissions(fetchedSystemPermissions)
  }

  setSystemPermissions = permissions => {
    this.systemPermissions = permissions
  }

  permissionData = () => {
    return {
      includes: this.includesPermissions,
      excludes: this.excludesPermissions,
    };
  }
}